// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__2dC-q","message":"CookieConsent_message__zDXY1","cookieLink":"CookieConsent_cookieLink__pabR0","continueBtn":"CookieConsent_continueBtn__2kGlr"};